import { API_URL } from 'constants';

export const DEFAULT_TIME_SHEET_URL = `${API_URL}/api/v1/timesheet`;
